// Next Diamonds — Cart inline editing v5 (line-key 2-step variant swap)
//
// Shopify's /cart/change.js rejects swap requests for lines that have line
// item properties unless we identify the line by its full line key
// (variant_id:32_hex). The simplest robust pattern:
//   1. Remove old line:  POST /cart/change.js  { id: <line_key>, quantity: 0 }
//   2. Add new variant:  POST /cart/add.js     { id: <new_variant>, quantity, properties }
//
// Engraving edits: same line key, change.js with properties:
//   POST /cart/change.js { id: <line_key>, quantity: <q>, properties: <new_props> }

(function () {
  'use strict';

  function getLineProperties(itemEl) {
    var script = itemEl.querySelector('script[data-cart-line-properties]');
    if (!script) return {};
    try {
      var obj = JSON.parse(script.textContent || '{}');
      var clean = {};
      Object.keys(obj).forEach(function (k) {
        // Keep underscore properties: _Carat drives the carat price in the
        // cart Function, and _Shape/_Color/_Clarity/_Cut/_Get it by feed the
        // checkout sticker. Dropping them here repriced edited lines at the
        // base carat (order #2706, 2026-09-18).
        if (obj[k] === null || obj[k] === '') return;
        clean[k] = obj[k];
      });
      return clean;
    } catch (e) {
      return {};
    }
  }

  function setLoading(itemEl, on) {
    if (!itemEl) return;
    if (on) itemEl.classList.add('is-loading');
    else itemEl.classList.remove('is-loading');
  }

  async function postJSON(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });
    var json = await res.json().catch(function () { return {}; });
    console.log('[ND cart]', url, body, '→', res.status, json);
    if (!res.ok) {
      var msg = json.description || json.message || ('HTTP ' + res.status);
      throw new Error(msg);
    }
    return json;
  }

  // Reload the page after cart changes. Pre-set a flag so the drawer
  // re-opens after reload, preserving the perceived "drawer stays open" UX.
  function refreshCart() {
    try {
      sessionStorage.setItem('nd-cart-reopen', '1');
    } catch (e) {}
    window.location.reload();
  }

  // ──────────────────────────────────────────────────────
  // In-place section refresh — keeps drawer open, no reload.
  // Called after any cart change that doesn't need a full reload
  // (e.g. PDP add-to-cart, coupon apply/remove, note save).
  //
  // NOTE: /cart?sections=... returns cart JSON. Use /?sections=...
  // (any non-cart URL) for the section render API to return HTML.
  // ──────────────────────────────────────────────────────
  var refreshInFlight = false;
  async function refreshCartSectionsInPlace() {
    if (refreshInFlight) return;
    refreshInFlight = true;
    try {
      var url = '/?sections=cart-drawer,main-cart&_=' + Date.now();
      var res = await fetch(url, {
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      var data = await res.json();
      var parser = new DOMParser();

      if (data['cart-drawer']) {
        var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        var newForm = doc.querySelector('cart-drawer cart-form, side-drawer cart-form, cart-form');
        var oldForm = document.querySelector('cart-drawer cart-form, side-drawer cart-form');
        if (newForm && oldForm) {
          oldForm.innerHTML = newForm.innerHTML;
        }
        // Also sync the footer wrapper class (hidden vs not-hidden).
        var newFooter = doc.querySelector('.cart-drawer__footer');
        var oldFooter = document.querySelector('cart-drawer .cart-drawer__footer, side-drawer .cart-drawer__footer');
        if (newFooter && oldFooter) oldFooter.className = newFooter.className;
        var newContent = doc.querySelector('.cart-drawer__content');
        var oldContent = document.querySelector('cart-drawer .cart-drawer__content, side-drawer .cart-drawer__content');
        if (newContent && oldContent) oldContent.className = newContent.className;
        var newEmpty = doc.querySelector('.cart-drawer__empty-content');
        var oldEmpty = document.querySelector('cart-drawer .cart-drawer__empty-content, side-drawer .cart-drawer__empty-content');
        if (newEmpty && oldEmpty) oldEmpty.className = newEmpty.className;
      }

      if (data['main-cart']) {
        var pageDoc = parser.parseFromString(data['main-cart'], 'text/html');
        var newPageForm = pageDoc.querySelector('cart-form');
        var oldPageForm = document.querySelector('.template-cart cart-form');
        if (newPageForm && oldPageForm) oldPageForm.innerHTML = newPageForm.innerHTML;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('[ND cart] section refresh failed:', err);
    } finally {
      refreshInFlight = false;
    }
  }
  // Expose for other cart scripts (cart-promo, cart-note, etc.)
  window.ND = window.ND || {};
  window.ND.refreshCartSectionsInPlace = refreshCartSectionsInPlace;

  // Hook into Symmetry's PDP add-to-cart flow. After Symmetry processes a
  // PDP `add`, the items list updates via data-merge but the summary block
  // can be stale (e.g. cart was empty at page load and Symmetry doesn't
  // re-render our cart-sum). We refresh just after Symmetry finishes.
  //
  // We DELIBERATELY do NOT auto-refresh after /cart/change.js or
  // /cart/update.js — those are our own AJAX calls (engraving save, note
  // save, coupon clear) which update the relevant UI inline. Refreshing
  // sections after them would collapse open forms and re-trigger
  // `loading="manual"` images that go blank.
  (function () {
    var nativeFetch = window.fetch;
    if (!nativeFetch || nativeFetch.__ndCartPatched) return;
    function patched(input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add\.js/.test(url)) {
        p.then(function () {
          setTimeout(refreshCartSectionsInPlace, 250);
        }).catch(function () {});
      }
      return p;
    }
    patched.__ndCartPatched = true;
    window.fetch = patched;
  })();

  // ──────────────────────────────────────────────────────
  // Variant swap (Metal / Size) — 2-step
  // ──────────────────────────────────────────────────────
  async function swapVariant(itemEl, newVariantId, properties) {
    setLoading(itemEl, true);
    try {
      var lineKey = itemEl.getAttribute('data-cart-line-key');
      var quantity = parseInt(itemEl.getAttribute('data-cart-line-quantity'), 10) || 1;

      // 1. remove old line by full line key
      await postJSON('/cart/change.js', { id: lineKey, quantity: 0 });

      // 2. add new variant with the same quantity + preserved properties
      await postJSON('/cart/add.js', {
        id: parseInt(newVariantId, 10),
        quantity: quantity,
        properties: properties
      });

      await refreshCart();
      setLoading(itemEl, false);
    } catch (err) {
      setLoading(itemEl, false);
      console.error('[ND cart] swap failed:', err);
      alert('Could not update cart: ' + err.message);
    }
  }

  // ──────────────────────────────────────────────────────
  // Engraving edit (no variant change) — single change.js with properties.
  // No full reload: we refresh just the cart sections in place so the drawer
  // stays open and feels instant.
  // ──────────────────────────────────────────────────────
  async function updateProperties(itemEl, newProperties) {
    setLoading(itemEl, true);
    try {
      var lineKey = itemEl.getAttribute('data-cart-line-key');
      var quantity = parseInt(itemEl.getAttribute('data-cart-line-quantity'), 10) || 1;

      await postJSON('/cart/change.js', {
        id: lineKey,
        quantity: quantity,
        properties: newProperties
      });

      // In-place section refresh (no window.location.reload). The drawer
      // stays open, the item's HTML re-renders with the new properties.
      await refreshCartSectionsInPlace();
      setLoading(itemEl, false);
    } catch (err) {
      setLoading(itemEl, false);
      console.error('[ND cart] props update failed:', err);
      alert('Could not update cart: ' + err.message);
    }
  }

  // ──────────────────────────────────────────────────────
  // 1. Metal / Size custom dropdown — trigger toggle + option swap
  // (Replaces native <select> which mispositions inside transformed drawers)
  // ──────────────────────────────────────────────────────

  // Cache /products/<handle>.js responses so we only fetch each product once
  // per session. Used to look up variant IDs without relying on Liquid's
  // product.variants (capped at 250) — works for products with up to 2,000
  // variants.
  var productDataCache = {};
  function getProductData(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (productDataCache[handle]) return Promise.resolve(productDataCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Product fetch HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        productDataCache[handle] = data;
        return data;
      });
  }

  // Given product data + current variant id + axis index + new option value,
  // find the variant that matches the requested combination. Returns null if
  // no such variant exists.
  function findVariantBySwappingAxis(productData, currentVariantId, axisIdx, newOptionValue) {
    var variants = productData.variants || [];
    var currentVariant = variants.find(function (v) { return v.id === currentVariantId; });
    if (!currentVariant) return null;
    var target = currentVariant.options.slice();
    target[axisIdx] = newOptionValue;
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === target[i]; });
    }) || null;
  }

  function closeAllSpecPanels(exceptEl) {
    document.querySelectorAll('[data-spec-panel]').forEach(function (p) {
      if (p === exceptEl) return;
      p.hidden = true;
      var row = p.closest('[data-spec-edit]');
      if (row) {
        var trig = row.querySelector('[data-spec-trigger]');
        if (trig) trig.setAttribute('aria-expanded', 'false');
        row.classList.remove('is-open');
      }
    });
  }

  document.addEventListener('click', function (e) {
    // Trigger click → toggle that row's panel + prefetch product data so
    // the option-click swap is instant.
    var trigger = e.target.closest('[data-spec-trigger]');
    if (trigger) {
      e.preventDefault();
      var row = trigger.closest('[data-spec-edit]');
      var panel = row && row.querySelector('[data-spec-panel]');
      if (!panel) return;
      var willOpen = panel.hidden;
      closeAllSpecPanels(willOpen ? panel : null);
      panel.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      row.classList.toggle('is-open', willOpen);
      if (willOpen) {
        var handle = row.getAttribute('data-product-handle');
        if (handle) getProductData(handle).catch(function () {});
      }
      return;
    }

    // Option click → resolve variant id (via /products/<handle>.js) then swap
    var option = e.target.closest('[data-spec-option]');
    if (option && !option.disabled) {
      e.preventDefault();
      var itemEl = option.closest('.item');
      if (!itemEl) return;
      var row2 = option.closest('[data-spec-edit]');
      if (!row2) return;
      closeAllSpecPanels();
      // Skip if it's already selected
      if (option.classList.contains('is-selected')) return;

      var newOptionValue = option.getAttribute('data-option-value');
      var handle = row2.getAttribute('data-product-handle');
      var axisIdx = parseInt(row2.getAttribute('data-option-index'), 10);
      var currentVariantId = parseInt(itemEl.getAttribute('data-cart-line-variant-id'), 10);
      if (newOptionValue == null || !handle || isNaN(axisIdx) || isNaN(currentVariantId)) return;

      var properties = getLineProperties(itemEl);
      setLoading(itemEl, true);
      getProductData(handle)
        .then(function (data) {
          var v = findVariantBySwappingAxis(data, currentVariantId, axisIdx, newOptionValue);
          if (!v) throw new Error('That combination is not available.');
          if (v.available === false) throw new Error('That combination is sold out.');
          setLoading(itemEl, false);
          return swapVariant(itemEl, v.id, properties);
        })
        .catch(function (err) {
          setLoading(itemEl, false);
          console.error('[ND cart] variant lookup failed:', err);
          alert('Could not update cart: ' + err.message);
        });
      return;
    }

    // Click outside any spec dropdown → close them all
    if (!e.target.closest('[data-spec-edit]')) {
      closeAllSpecPanels();
    }
  }, true);  // capture phase so we run before other click handlers

  // ──────────────────────────────────────────────────────
  // 2. Engraving inline editor
  // ──────────────────────────────────────────────────────
  function openEngraving(specRow) {
    var itemEl = specRow.closest('.item');
    if (!itemEl) return;
    var form = itemEl.querySelector('[data-engraving-form]');
    if (!form) return;
    specRow.hidden = true;
    form.hidden = false;
    var input = form.querySelector('input');
    if (input) {
      input.focus();
      input.setSelectionRange(input.value.length, input.value.length);
    }
  }

  function closeEngravingForms() {
    document.querySelectorAll('[data-engraving-form]').forEach(function (f) {
      if (f.hidden) return;
      f.hidden = true;
      var item = f.closest('.item');
      if (!item) return;
      item.querySelectorAll('.specs__row[data-edit-engraving][hidden]').forEach(function (r) {
        r.hidden = false;
      });
    });
  }

  document.addEventListener('click', function (e) {
    // (Legacy open/close handlers removed — engraving input is now always
    // visible, so there's no "Edit" button to open it and no "Cancel" to
    // close. We just listen for the Save click below.)

    var cancelBtn = e.target.closest('[data-engraving-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var formC = cancelBtn.closest('[data-engraving-form]');
      var itemC = cancelBtn.closest('.item');
      // Reset input value to whatever was originally saved
      if (formC && itemC) {
        var origInput = formC.querySelector('input[name="engraving"]');
        var props = getLineProperties(itemC);
        if (origInput) origInput.value = props.Engraving || '';
      }
      closeEngravingForms();
      return;
    }

    // Edit/Save toggle button. First click: enter edit mode (input editable,
    // label changes to "Save"). Second click: persist via /cart/change.js,
    // return to read-only with the label back to "Edit".
    var toggleBtn = e.target.closest('[data-engraving-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var formT = toggleBtn.closest('[data-engraving-form]');
      var inputT = formT && formT.querySelector('input[name="engraving"]');
      if (!inputT) return;
      var isEditing = toggleBtn.classList.contains('is-editing');
      if (!isEditing) {
        // Enter edit mode
        inputT.removeAttribute('readonly');
        inputT.focus();
        try { inputT.setSelectionRange(inputT.value.length, inputT.value.length); } catch (e2) {}
        toggleBtn.textContent = 'Save';
        toggleBtn.classList.add('is-editing');
        return;
      }
      // Else: fall through to the save path below by morphing this into a
      // synthetic "save" click on the same button.
      // (The save code expects `saveBtn` so we just reuse this var.)
      var saveBtn = toggleBtn;
      var form = formT;
      var itemEl = form.closest('.item');
      if (!itemEl) return;
      var input = inputT;
      var newVal = (input && input.value || '').trim();
      var props = getLineProperties(itemEl);
      if (newVal) props.Engraving = newVal;
      else delete props.Engraving;

      // No section refresh, no collapse. Update the cart line, then update
      // the displayed engraving text inline and flash "Saved ✓" on the
      // button. The form stays open — user can edit again immediately.
      var origLabel = saveBtn.dataset.ndOrigLabel || saveBtn.textContent;
      saveBtn.dataset.ndOrigLabel = origLabel;
      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving…';

      var lineKey = itemEl.getAttribute('data-cart-line-key');
      var qty = parseInt(itemEl.getAttribute('data-cart-line-quantity'), 10) || 1;
      setLoading(itemEl, true);
      postJSON('/cart/change.js', { id: lineKey, quantity: qty, properties: props })
        .then(function (res) {
          // Adopt the new line key (the properties hash changed it).
          var variantId = parseInt(itemEl.getAttribute('data-cart-line-variant-id'), 10);
          var newLine = (res.items || []).find(function (l) { return l.variant_id === variantId; });
          if (newLine) itemEl.setAttribute('data-cart-line-key', newLine.key);

          // Update the stashed properties JSON so future reads see the new value.
          var script = itemEl.querySelector('script[data-cart-line-properties]');
          if (script) {
            var clean = {};
            Object.keys(props).forEach(function (k) {
              if (props[k] && props[k] !== '') clean[k] = props[k];
            });
            script.textContent = '\n      ' + JSON.stringify(clean) + '\n    ';
          }

          // No separate display row to update — the input itself IS the
          // displayed engraving value now. Just make sure the input reflects
          // the saved value (in case of trimming).
          if (input) input.value = newVal;

          // Flash "Saved ✓", then return to read-only "Edit" state.
          saveBtn.textContent = 'Saved ✓';
          saveBtn.classList.add('is-saved');
          setLoading(itemEl, false);
          setTimeout(function () {
            saveBtn.textContent = 'Edit';
            saveBtn.classList.remove('is-saved');
            saveBtn.classList.remove('is-editing');
            saveBtn.disabled = false;
            // Re-lock the input so the customer can't accidentally edit it
            // until they tap Edit again. This matches the new toggle UX.
            if (input) input.setAttribute('readonly', '');
          }, 1400);
        })
        .catch(function (err) {
          console.error('[ND cart] engraving save failed:', err);
          setLoading(itemEl, false);
          saveBtn.textContent = 'Error';
          setTimeout(function () {
            saveBtn.textContent = 'Edit';
            saveBtn.classList.remove('is-editing');
            saveBtn.disabled = false;
            if (input) input.setAttribute('readonly', '');
          }, 1800);
        });
      return;
    }

    // Item collapse/expand toggle
    var toggleEl = e.target.closest('[data-item-toggle]');
    if (toggleEl) {
      e.preventDefault();
      var item = toggleEl.closest('.item');
      if (item) item.classList.toggle('is-collapsed');
      return;
    }

    // Item remove — intercept the plain anchor and AJAX the change so the
    // drawer stays open (instead of navigating to /cart).
    var removeEl = e.target.closest('.item__remove');
    if (removeEl) {
      e.preventDefault();
      var itemElR = removeEl.closest('.item');
      if (!itemElR) return;
      var lineKey = itemElR.getAttribute('data-cart-line-key');
      setLoading(itemElR, true);
      postJSON('/cart/change.js', { id: lineKey, quantity: 0 })
        .then(function () { refreshCart(); })
        .catch(function (err) {
          setLoading(itemElR, false);
          console.error('[ND cart] remove failed:', err);
          alert('Could not remove item: ' + err.message);
        });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeEngravingForms();
  });

  // ──────────────────────────────────────────────────────
  // Re-open the drawer on load if a recent cart edit set the flag
  // ──────────────────────────────────────────────────────
  function reopenIfFlagged() {
    try {
      if (sessionStorage.getItem('nd-cart-reopen') === '1') {
        sessionStorage.removeItem('nd-cart-reopen');
        // Symmetry's cart drawer is opened by clicking [data-cart-drawer-open]
        // or by dispatching a 'cart:open' event. Try a few patterns to be safe.
        var trigger = document.querySelector(
          '[data-cart-drawer-open], a[href="#cart-drawer"], a[href*="/cart"][data-drawer]'
        );
        var drawer = document.querySelector('cart-drawer, side-drawer.js-cart-drawer, .js-cart-drawer');
        // Tiny delay so Symmetry's own drawer JS finishes initialising.
        setTimeout(function () {
          if (drawer && typeof drawer.show === 'function') {
            drawer.show();
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (trigger) {
            trigger.click();
          } else {
            // Fallback: dispatch a custom event for any listener.
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        }, 200);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenIfFlagged);
  } else {
    reopenIfFlagged();
  }
})();
